<template lang="html">
   <div class="radio-row" :class="classes.radioRow">
      <div class="radio-content" v-for="(radio,i) in updated_options" :key="i" :class="radio.class">
         <input 
            type="checkbox" 
            class="radio-input"
            :name="id" 
            :id="name+i" 
            :checked="radio.checked"
            @change="updateSelf($event.target.value,radio)">
         <label class="radio-label" :for="name+i" v-html="radio.label"></label>
      </div>
   </div>
</template>

<script>
export default {
   props: {
      type: {
         default: ''
      },
      options: {
         default: function(){
            return []
         }
      },
      name: {
         default: ''
      },
      classes: {
         default: function(){
            return {
               radioRow: '',
               radioCol: '',
            }
         }
      },
      model: {
         default: function(){
            return []
         }
      },
      elClass: {
         default: 'funkyradio'
      },
      action: {
         default: ''
      }
   },
   watch:{
      model(newVal,oldVal){
         if(this.displayItems !== newVal){
            this.updateComponent(newVal)
         }
      },
      options(oldVal,newVal){
         this.updateOptions()
      }
   },
   data () {
      return {
         id: '',
         updated_options: [],
         items: [],
         displayItems: []
      }
   },
   methods: {
      updateComponent(values){
         // Reset Values First
         this.items = []
         this.displayItems = []
         this.updateOptions()
         
         for (let i = 0; i < this.updated_options.length; i++) {
            let option = this.updated_options[i]
            option.checked = false
         }
         
         // Populate new values
         for (let i = 0; i < values.length; i++) {
            const val = values[i];
            
            if(typeof val === 'string' || typeof val === 'number'){
               // TODO Logic to select all when all items are 
               for (let j = 0; j < this.updated_options.length; j++) {
                  const option = this.updated_options[j];
                  
                  if(val === option.val){
                     this.items.push({id: option.id, val: option.val});
                     this.displayItems.push(val)
                     option.checked = true;
                     break;
                  }
               }
            }else{
               // TODO Logic to handle objects
            }
         }
      },
      updateSelf($event,radio) {
         if(event.target.checked){
            if(radio.select_all){
               this.items = []

               for (let i = 0; i < this.updated_options.length; i++) {
                  const option = this.updated_options[i];

                  if(!option.select_all){
                     this.items.push({id:option.id, val:option})
                     this.displayItems.push(option.val)
                  }
                  option.checked = true
               }
            }else{
               this.addItem(radio.id,radio.val)
               if(this.displayItems.length === (this.updated_options.length - 1)){
                  for (let i = 0; i < this.updated_options.length; i++) {
                     const option = this.updated_options[i];
                     if(option.select_all){option.checked = true}
                  }
               }
            }
         }else{
            if(radio.select_all){
               this.items = []
               this.displayItems = []
               
               for (let i = 0; i < this.updated_options.length; i++) {
                  this.updated_options[i].checked = false;
               }
            }else{
               if(this.displayItems.length != this.updated_options.length){
                  for (let i = 0; i < this.updated_options.length; i++) {
                     const option = this.updated_options[i];
                     if(option.select_all){option.checked = false}
                  }
               }
               this.removeItem(radio.id)
            }
         }

         this.$emit("input", this.displayItems);
      },
      updateOptions(){
         this.updated_options = []

         for (let i = 0; i < this.options.length; i++) {
            const opt = this.options[i];
            opt.id = Math.round(Math.random() * 100000)
            
            this.updated_options.push(opt)
         }
      },
      addItem(id,val){
         this.items.push({id,val})
         this.displayItems.push(val)
      },
      removeItem(id){
         for (let i = 0; i < this.items.length; i++) {
            const item = this.items[i];
            
            if(item.id === id){
               this.items.splice(i,1)
               this.displayItems.splice(i,1)
            }
         }
      },
      selectAll(){

      }
   },
   mounted(){
      this.updateOptions()
   }
}
</script>